<div class="containers">
    <div class="catalogs-component">
        <div class="header">
            <div class="title" *ngIf="product">{{"inventory.catalogs.title" | translate}}</div>
            <div class="actions">
                <div *ngIf="productCatalogsData?.variants && productCatalogsData?.variants!.length > 1" class="standard-input standard-input-variant">
                    <mat-select [formControl]="variantControl">
                        <mat-option value="all_variants">{{"inventory.product_details.all_variants" | translate}}</mat-option>
                        <mat-option *ngFor="let variant of variants" [value]="variant.variant_id">{{ variant.values.join(' / ') }}</mat-option>
                    </mat-select>
                  </div>
            </div>
        </div>
        <div class="catalogs-list-container" *ngIf="productCatalogs && productCatalogs.length > 0">
            <!-- Table Header -->
            <div class="catalog-header-row">
                <div class="catalog-name-cell">
                    <span class="header-title">{{"inventory.catalogs.name" | translate}}</span>
                </div>
                <div class="col-cell">
                    <span class="header-title">{{"inventory.catalogs.orders_qty" | translate}}</span>
                </div>
                <div class="col-cell">
                    <span class="header-title">{{"inventory.catalogs.orders" | translate}}</span>
                </div>
                <div class="col-cell">
                    <span class="header-title">{{"inventory.catalogs.price" | translate}}</span>
                </div>
                <div class="col-cell">
                    <span class="header-title">{{"inventory.catalogs.last_order" | translate}}</span>
                </div>
                <div class="col-cell">
                    <span class="header-title">{{"inventory.catalogs.status" | translate}}</span>
                </div>
            </div>

            <div class="catalogs-rows-wrapper">
                <ng-container *ngFor="let productCatalog of productCatalogs; let i = index">
                    <div class="catalog-row">
                        <div class="catalog-name-cell">
                            <span class="col-value">{{productCatalog.catalog_name}}</span><br>
                            <span class="tag type-tag" [title]="productCatalog.type">
                                <img [src]="catalogTypeIcon(productCatalog.type!)" alt="" >
                                {{ ('Catalogs.new_catalog.settings.catalog_types.' + productCatalog.type!) | translate }}
                              </span>
                        </div>
                        <div class="col-cell">
                            <div class="col-value">{{productCatalog.orders_qty? productCatalog.orders_qty : "--"}}</div>
                        </div>
                        <div class="col-cell">
                            <div class="col-value">{{productCatalog.orders_value? (productCatalog.orders_value | number:'1.2-2') + " €" : "--"}}</div>
                        </div>
                        <div class="col-cell">
                            <span class="col-value">{{ productCatalog.price | number:'1.2-2' }}</span> €<br>
                            <span class="light_span">{{ (product.sales_price ? 100 - (productCatalog.price * 100 / product.sales_price) : 0) | number:'1.0-0'}}% MSRP</span>
                        </div>
                        <div class="col-cell">
                            <div class="col-value">{{productCatalog.last_order? (productCatalog.last_order | date : DATE_FORMAT) : "--"}}</div>
                        </div>
                        <div class="col-cell">
                            <ui-status-badge
                                *ngIf="productCatalog.status"
                                size="small"
                                [tone]="catalogStatusTone(productCatalog.status)"
                                [label]="('inventory.catalogs.values.' + productCatalog.status) | translate"
                              ></ui-status-badge>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="no-data" *ngIf="productCatalogs && productCatalogs.length === 0">
            <img src="assets/images/bloc-note.svg" alt="">
            <span>{{"inventory.product_details.not_enough_data_available" | translate}}</span>
        </div>

        <!-- Pricing rules & Promotions hidden front-end-wide due to business decision (WB-6694).
             Not deleted — gated by loyaltyEnabled, which is forced to false in FeatureFlagService. -->
        <ng-container *ngIf="featureFlags.loyaltyEnabled">

        <div style="display: flex; flex-direction: column; gap: 4px;">
            <div class="title">{{"inventory.catalogs.pricing_rules.title" | translate}}</div>
            <span style="display: flex; gap: 6px;"><img class="margin-right: 6px;" src="assets/icones/info.svg" alt="" /><span class="light_span">{{"inventory.catalogs.pricing_rules.description" | translate}}</span></span>
        </div>
        
        <div class="catalogs-list-container" *ngIf="productPricingRules.length > 0">
            <div class="catalog-header-row">
                <div class="price-rule-cell">
                    <span class="header-title">{{"inventory.catalogs.name" | translate}}</span>
                </div>
                <div class="price-rule-cell">
                    <span class="header-title">{{"inventory.catalogs.audience" | translate}}</span>
                </div>
                <div class="price-rule-cell">
                    <span class="header-title">{{"inventory.catalogs.calculation_type" | translate}}</span>
                </div>
                <div class="price-rule-status-cell">
                    <span class="header-title">{{"inventory.catalogs.status" | translate}}</span>
                </div>
            </div>

            <div class="catalogs-rows-wrapper">
                <ng-container *ngFor="let pricingRule of productPricingRules">
                    <div class="catalog-row">
                        <div class="price-rule-cell">
                            <div class="col-value">{{pricingRule.name}}</div>
                        </div>
                        <div class="price-rule-cell">
                            <span class="col-value">{{ pricingRule.audience }}</span><br>
                        </div>
                        <div class="price-rule-cell">
                            <div class="block_data" [title]="getPricebookCalculationTypeDisplayText(pricingRule.calculation_type!)">
                                {{ getPricebookCalculationTypeDisplayText(pricingRule.calculation_type!) | displayText : 25 }}
                                <span class="secondary-text-bold" *ngIf="pricingRule.calculation_type === 'extra_discount_on_products' || pricingRule.calculation_type === 'extra_discount_on_full_order'">{{ (pricingRule.thresholds.length > 0 ? 'pricebook.up_to' : '') | translate }} {{ pricingRule.extra_discount | number:'1.0-2' }}% {{ 'pricebook.form.extra_discount' | translate }}</span>
                            </div>
                        </div>
                        <div class="price-rule-status-cell">
                            
                            <span class="col-value item_tag_status" [class]="pricingRule.active  ? 'approved' : 'inactive'">
                                {{ (pricingRule.active ? "pricebook.active" : "pricebook.inactive") | translate }}
                            </span>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div> 

        <!-- Promotions -->

        <div style="display: flex; flex-direction: column; gap: 4px;">
            <div class="title">{{"inventory.catalogs.promotions.title" | translate}}</div>
            <span style="display: flex; gap: 6px;"><img class="margin-right: 6px;" src="assets/icones/info.svg" alt="" /><span class="light_span">{{"inventory.catalogs.promotions.description" | translate}}</span></span>
        </div>
        <div class="catalogs-list-container" *ngIf="productPromotions.length > 0">
            <div class="catalog-header-row">
                <div class="promotion-cell">
                    <span class="header-title">{{"inventory.catalogs.name" | translate}}</span>
                </div>
                <div class="promotion-cell">
                    <span class="header-title">{{"inventory.catalogs.audience" | translate}}</span>
                </div>
                <div class="promotion-cell">
                    <span class="header-title">{{"inventory.catalogs.calculation_type" | translate}}</span>
                </div>
            </div>

            <div class="catalogs-rows-wrapper">
                <ng-container *ngFor="let promotion of productPromotions">
                    <div class="catalog-row">
                        <div class="promotion-cell">
                            <div class="col-value">{{promotion.name}}</div>
                        </div>
                        <div class="promotion-cell">
                            <span class="col-value">{{ promotion.audience }}</span><br>
                        </div>
                        <div class="promotion-cell">
                            <div class="block_data" [title]="getPricebookCalculationTypeDisplayText(promotion.calculation_type!)">
                                {{ getPricebookCalculationTypeDisplayText(promotion.calculation_type!) | displayText : 25 }}
                                <span class="secondary-text-bold" *ngIf="promotion.calculation_type === 'extra_discount_on_products' || promotion.calculation_type === 'extra_discount_on_full_order'">{{ (promotion.thresholds.length > 0 ? 'pricebook.up_to' : '') | translate }} {{ promotion.extra_discount | number:'1.0-2' }}% {{ 'pricebook.form.extra_discount' | translate }}</span>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        </ng-container>
    </div>
</div>